var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pack-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "29.6078569%",
    cy: "73.0579714%",
    fx: "29.6078569%",
    fy: "73.0579714%",
    r: "56.6756552%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100,0 C168.429045,0 200,39.2500126 200,100 C200,160.749987 170.303194,200 100,200 C29.6968058,200 0,163.066536 0,100 C0,36.9334635 31.5709552,0 100,0 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.31799894%",
    y1: "17.9315911%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F868B7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3781",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2363636,20.4533333 C16.8559424,20.4533333 15.7333333,21.5693966 15.7333333,22.9417687 L15.7333333,35.3839456 C15.7333333,36.7563177 16.8559424,37.872381 18.2363636,37.872381 L34.5060606,37.872381 C35.8864818,37.872381 37.0090909,36.7563177 37.0090909,35.3839456 L37.0090909,31.7533569 L41.2329545,35.111773 C41.4594788,35.2909403 41.7360636,35.3839456 42.0151515,35.3839456 C42.1991242,35.3839456 42.3850919,35.3421287 42.557801,35.2600103 C42.9920767,35.0534702 43.2666667,34.6175075 43.2666667,34.1397279 L43.2666667,24.1859864 C43.2666667,23.7082068 42.9920767,23.2710588 42.557801,23.0632743 C42.1247767,22.8579784 41.6084091,22.9153291 41.2329545,23.2139413 L37.0090909,26.5723571 L37.0090909,22.9417687 C37.0090909,21.5693966 35.8864818,20.4533333 34.5060606,20.4533333 L18.2363636,20.4533333 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-79.9%",
    y: "-114.8%",
    width: "259.8%",
    height: "352.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Branding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-161.000000, -2080.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pack-1",
    transform: "translate(161.000000, 2080.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#radialGradient-1)",
    transform: "translate(100.000000, 100.000000) scale(1, -1) translate(-100.000000, -100.000000) ",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47,8 C47,17.9411255 55.0588745,26 65,26 C68.7007393,26 72.1406331,24.8831875 75.0010342,22.9682096 L75,55 C75,66.045695 66.045695,75 55,75 L20,75 C8.954305,75 1.3527075e-15,66.045695 0,55 L0,20 C-1.3527075e-15,8.954305 8.954305,2.02906125e-15 20,0 L48.8707875,0.000506771571 C47.6733178,2.41029875 47,5.12651848 47,8 Z",
    id: "Combined-Shape",
    fill: "#F89422"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(22.004545, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4217857,36.011875 C31.3395536,30.7445536 29.6985714,25.9550893 26.7809821,22.4874107 C23.8803571,19.0408929 19.9492857,17.1428571 15.7107143,17.1428571 C11.4721429,17.1428571 7.54107143,19.0408929 4.64044643,22.4874107 C1.725625,25.9514286 0.0857142857,30.7341964 0,35.995 C1.64821429,36.820625 8.46875,40 15.7107143,40 C23.5417857,40 29.8933036,36.8392857 31.4217857,36.011875 L31.4217857,36.011875 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 15.7107143,
    cy: 7.85714286,
    r: 7.85714286
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,6 C37,13.1797017 42.8202983,19 50,19 C53.2760048,19 56.2689847,17.7882264 58.5551637,15.7884552 C58.846801,17.1461994 59,18.5552089 59,20 L59,39 C59,50.045695 50.045695,59 39,59 L20,59 C8.954305,59 1.3527075e-15,50.045695 0,39 L0,20 C-1.3527075e-15,8.954305 8.954305,2.02906125e-15 20,0 L38.4641519,0.000516769206 C37.5287681,1.79540917 37,3.83595438 37,6 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "gear-fill",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(15.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.634375,1.96875 C16.86,-0.65625 13.14,-0.65625 12.365625,1.96875 L12.178125,2.60625 C11.9437838,3.40220214 11.3619907,4.0494451 10.5954284,4.3669949 C9.82886609,4.68454469 8.95980333,4.63832135 8.23125,4.24125 L7.65,3.9225 C5.244375,2.61375 2.61375,5.244375 3.924375,7.648125 L4.24125,8.23125 C5.0775,9.76875 4.284375,11.683125 2.60625,12.178125 L1.96875,12.365625 C-0.65625,13.14 -0.65625,16.86 1.96875,17.634375 L2.60625,17.821875 C3.40220214,18.0562162 4.0494451,18.6380093 4.3669949,19.4045716 C4.68454469,20.1711339 4.63832135,21.0401967 4.24125,21.76875 L3.9225,22.35 C2.61375,24.755625 5.244375,27.38625 7.648125,26.075625 L8.23125,25.75875 C8.95980333,25.3616786 9.82886609,25.3154553 10.5954284,25.6330051 C11.3619907,25.9505549 11.9437838,26.5977979 12.178125,27.39375 L12.365625,28.03125 C13.14,30.65625 16.86,30.65625 17.634375,28.03125 L17.821875,27.39375 C18.0562162,26.5977979 18.6380093,25.9505549 19.4045716,25.6330051 C20.1711339,25.3154553 21.0401967,25.3616786 21.76875,25.75875 L22.35,26.0775 C24.755625,27.38625 27.38625,24.755625 26.075625,22.351875 L25.75875,21.76875 C25.3616786,21.0401967 25.3154553,20.1711339 25.6330051,19.4045716 C25.9505549,18.6380093 26.5977979,18.0562162 27.39375,17.821875 L28.03125,17.634375 C30.65625,16.86 30.65625,13.14 28.03125,12.365625 L27.39375,12.178125 C26.5977979,11.9437838 25.9505549,11.3619907 25.6330051,10.5954284 C25.3154553,9.82886609 25.3616786,8.95980333 25.75875,8.23125 L26.0775,7.65 C27.38625,5.244375 24.755625,2.61375 22.351875,3.924375 L21.76875,4.24125 C21.0401967,4.63832135 20.1711339,4.68454469 19.4045716,4.3669949 C18.6380093,4.0494451 18.0562162,3.40220214 17.821875,2.60625 L17.634375,1.96875 L17.634375,1.96875 Z M15,20.49375 C11.9658857,20.49375 9.50625,18.0341143 9.50625,15 C9.50625,11.9658857 11.9658857,9.50625 15,9.50625 C18.0330788,9.50625 20.4918749,11.9650462 20.4918749,14.998125 C20.4918749,18.0312038 18.0330788,20.49 15,20.49 L15,20.49375 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, -20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F89422",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 59,
    height: 59,
    rx: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fill: "none",
    fillRule: "nonzero",
    transform: "translate(29.500000, 29.162857) rotate(-1.000000) translate(-29.500000, -29.162857) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-lock2",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EF1554",
    fillRule: "evenodd",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2916469,8.08789232 C19.0695318,7.86655247 18.7669212,7.74510966 18.4534158,7.75149588 C18.1399103,7.7578821 17.8424963,7.89154763 17.6295793,8.12174925 L12.2848008,14.9316095 L9.06377539,11.7090451 C8.60900022,11.2852812 7.90031311,11.2977852 7.46076999,11.7373283 C7.02122686,12.1768714 7.0087229,12.8855585 7.43248683,13.3403337 L11.5045524,17.4139383 C11.7261994,17.6351815 12.0282338,17.7568615 12.3413508,17.7510577 C12.6544677,17.7452538 12.9517853,17.6124644 13.1650811,17.3831592 L19.3085754,9.70379137 C19.7442494,9.25080433 19.7374084,8.5324994 19.2931859,8.08789232 L19.2916469,8.08789232 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-lock2-copy",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.000000, 136.000000)",
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5A2B6F",
    cx: 10.5,
    cy: 10.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5817148,6.53252841 C15.4023142,6.35375391 15.1578979,6.25566549 14.904682,6.26082359 C14.651466,6.2659817 14.411247,6.37394232 14.2392756,6.5598744 L9.92233914,12.0601462 L7.32074166,9.4573057 C6.95342325,9.11503483 6.38102213,9.12513418 6.02600653,9.48014979 C5.67099092,9.83516539 5.66089157,10.4075665 6.00316244,10.7748849 L9.29213851,14.065104 C9.47116106,14.2438004 9.7151119,14.3420804 9.96801407,14.3373927 C10.2209162,14.332705 10.4610574,14.225452 10.6333347,14.040244 L15.5953878,7.83767765 C15.9472783,7.47180349 15.9417529,6.89163413 15.5829578,6.53252841 L15.5817148,6.53252841 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack1);
export default __webpack_public_path__ + "static/media/pack-1.c8da9e29cf57254631ec78662a968422.svg";
export { ForwardRef as ReactComponent };